import { User } from '../../../shared-src/user'
import { getFeathersClient } from '@/pages/chat/feathers-client'
import { useUserStore } from './user-store'

//	returns:
//		- the user on success
//		- null on definitive auth loss (401/403 from the users service, or no userId available)
//		- throws on transient failures (network / socket / 5xx / task-worker timeout).
//	callers can only treat null as "log out and bounce". throwing means "leave session
//	and user store intact — the caller will retry naturally". mirrors the classification
//	that use-session.ts:refreshSession() already does for /api/v1/me.
export async function fetchUser(userId?: string): Promise<User | null> {
	const feathersClient = getFeathersClient()
	const userService = feathersClient.service('users')
	const currentUser = useUserStore.getState().user
	userId = userId || currentUser?.userId
	if (!userId) {
		useUserStore.getState().setUser(null)
		return null
	}
	try {
		const user = await userService.get(userId)
		useUserStore.getState().setUser(user)
		return user
	} catch (err) {
		const code = (err as { code?: number })?.code
		if (code === 401 || code === 403) {
			console.warn('Auth failure fetching user:', err)
			useUserStore.getState().setUser(null)
			return null
		}
		console.error('Transient failure fetching user (leaving state intact):', err)
		throw err
	}
}

export async function uploadUser(): Promise<void> {
	const user = useUserStore.getState().user
	if (!user)
		throw new Error('User not found')

	const updatedUser: Partial<User> = user
	updatedUser.email = undefined
	updatedUser.isDeveloper = undefined

	const feathersClient = getFeathersClient()
	const userService = feathersClient.service('users')
	await userService.patch(user.userId, user)
}
